var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body1"},[_c('Info',{attrs:{"selfStyle":"padding-left: 0;"}}),_c('Reply',{attrs:{"selfStyle":"padding-left: 0;"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }